<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    fill="currentColor"
  >
    <path
      d="M24 3a21 21 0 1 0 21 21A21 21 0 0 0 24 3zm0 40a19 19 0 1 1 19-19 19 19 0 0 1-19 19zm8.24-26.33a1 1 0 0 1 .25 1.4l-9 13a1 1 0 0 1-.75.43h-.07a1 1 0 0 1-.73-.32l-5.17-5.5a1 1 0 1 1 1.46-1.36l4.32 4.59 8.29-12a1 1 0 0 1 1.4-.24z"
    />
  </svg>
</template>
